import React from "react";
import { cn } from "../../lib/utils";

/**
 * EmptyState — friendly guidance to next action. Use on all list/detail
 * screens when the underlying resource has no data yet.
 */
export function EmptyState({
  title, description, action, icon, className, "data-testid": testId,
}) {
  return (
    <div
      data-testid={testId || "empty-state"}
      className={cn(
        "flex flex-col items-center justify-center rounded border border-dashed border-slate-300 bg-white/60 px-6 py-16 text-center",
        className,
      )}
    >
      {icon && <div className="mb-4 text-slate-400">{icon}</div>}
      <h3 className="text-base font-semibold text-slate-800">{title}</h3>
      {description && (
        <p className="mt-1 max-w-md text-sm text-slate-500">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
